import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors"; 

function Hiring() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.7,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div style={{ background: "#ffffff", minHeight: "100vh" }} className="flex justify-center items-start p-6">
      <div className="w-full max-w-7xl">
        {/* Page Title */}
       

        {/* GRID: 3 columns desktop, 1 mobile */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>
          
          {/* Create Job Opening */}
          <Link to="/createOpening" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-briefcase" style={{ ...iconStyle, color: "#06B6D4" }}></i>
              <div>
                <h2 style={heading}>Create Job Opening</h2>
                <p style={subheading}>Add new teaching or non-teaching job openings.</p>
              </div>
            </div>
          </Link>

          {/* View Current Openings */}
          <Link to="/viewOpenings" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-folder-open" style={{ ...iconStyle, color: colors.primary }}></i>
              <div>
                <h2 style={heading}>View Current Openings</h2>
                <p style={subheading}>Check all current job openings and status.</p>
              </div>
            </div>
          </Link>
       </div>
      </div>
    </div>
  );
}

export default Hiring;
